import React, { useEffect, useState } from 'react';
import { useAdminAuth } from '../../context/AdminAuthContext';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHeader from '../../components/admin/AdminHeader';
import { UsersIcon, SearchIcon, FilterIcon, ChevronDownIcon, RefreshCwIcon, DownloadIcon, PlusIcon, EyeIcon, EditIcon, TrashIcon, MoreHorizontalIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, ArrowUpIcon, ArrowDownIcon, CalendarIcon, ClockIcon, UserPlusIcon, UserIcon, BuildingIcon, KeyIcon, MailIcon, PhoneIcon, ShieldIcon, LockIcon, UnlockIcon, CheckIcon, XIcon, ChevronLeftIcon, ChevronRightIcon, HelpCircleIcon, InfoIcon, AlertTriangleIcon, FileTextIcon, SendIcon, ArrowRightIcon, UserCheckIcon, UserXIcon, ClipboardIcon, ListIcon, BellIcon, TagIcon, MapPinIcon, HashIcon, AtSignIcon, CreditCardIcon, GlobeIcon } from 'lucide-react';
// Mock data generator for users
const generateMockUsers = (count: number, mdaId?: string) => {
  const statuses = ['Active', 'Inactive', 'Pending', 'Suspended'];
  const roles = ['Citizen', 'Business Owner', 'Government Employee', 'Foreigner', 'NGO Representative'];
  const mdas = ['Ministry of Finance', 'Ministry of Lands and Surveys', 'Ministry of Commerce and Industry', 'Federal Road Safety Commission', 'Ministry of Education'];
  const mockData = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const role = roles[Math.floor(Math.random() * roles.length)];
    // For MDA admins, ensure some users are associated with their MDA
    let userMdas = [];
    if (mdaId) {
      // For MDA admins, 80% of users should be associated with their MDA
      if (Math.random() < 0.8) {
        userMdas = [mdaId];
      } else {
        // 20% of users have random MDA associations (could include the admin's MDA too)
        const randomMda = mdas[Math.floor(Math.random() * mdas.length)];
        userMdas = [randomMda];
      }
    } else {
      // For super admins, users can be associated with 0-3 MDAs
      const mdaCount = Math.floor(Math.random() * 3);
      const selectedMdas = new Set();
      for (let j = 0; j < mdaCount; j++) {
        const randomMda = mdas[Math.floor(Math.random() * mdas.length)];
        selectedMdas.add(randomMda);
      }
      userMdas = Array.from(selectedMdas);
    }
    const daysAgo = Math.floor(Math.random() * 365);
    const registrationDate = new Date(now);
    registrationDate.setDate(registrationDate.getDate() - daysAgo);
    const lastLoginDaysAgo = Math.floor(Math.random() * daysAgo);
    const lastLoginDate = new Date(now);
    lastLoginDate.setDate(lastLoginDate.getDate() - lastLoginDaysAgo);
    // Generate random user info
    const userId = `USER-${Math.floor(Math.random() * 100000).toString().padStart(5, '0')}`;
    const firstName = ['John', 'Jane', 'Michael', 'Sarah', 'David', 'Emily', 'Robert', 'Jennifer', 'Christopher', 'Amanda', 'Daniel', 'Jessica', 'Matthew', 'Elizabeth', 'Joseph', 'Chinua', 'Ngozi', 'Oluwaseun', 'Chioma', 'Adebayo', 'Folake', 'Emeka', 'Amara', 'Ibrahim', 'Fatima', 'Mohammed', 'Aisha', 'Yusuf', 'Zainab', 'Aliyu'][Math.floor(Math.random() * 30)];
    const lastName = ['Smith', 'Johnson', 'Williams', 'Jones', 'Brown', 'Davis', 'Miller', 'Wilson', 'Moore', 'Taylor', 'Anderson', 'Thomas', 'Jackson', 'White', 'Harris', 'Martin', 'Okonkwo', 'Adeyemi', 'Okafor', 'Nwachukwu', 'Eze', 'Okoro', 'Afolayan', 'Adebisi', 'Mohammed', 'Ibrahim', 'Yusuf', 'Abdullahi', 'Bello', 'Musa', 'Abubakar', 'Suleiman'][Math.floor(Math.random() * 32)];
    const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}${Math.floor(Math.random() * 1000)}@example.com`;
    const phone = `+234${Math.floor(Math.random() * 10000000000).toString().padStart(10, '0')}`;
    // Generate random verification status
    const isEmailVerified = Math.random() > 0.2;
    const isPhoneVerified = Math.random() > 0.3;
    const isIdVerified = Math.random() > 0.4;
    // Generate random activity data
    const applicationCount = Math.floor(Math.random() * 20);
    const paymentCount = Math.floor(Math.random() * applicationCount);
    const completedServiceCount = Math.floor(Math.random() * paymentCount);
    // Only include users for the specified MDA if mdaId is provided
    if (!mdaId || userMdas.includes(mdaId)) {
      mockData.push({
        id: `user-${i}-${Date.now()}`,
        userId,
        firstName,
        lastName,
        email,
        phone,
        status,
        role,
        mdas: userMdas,
        registrationDate: registrationDate.toISOString(),
        lastLoginDate: lastLoginDate.toISOString(),
        isEmailVerified,
        isPhoneVerified,
        isIdVerified,
        applicationCount,
        paymentCount,
        completedServiceCount,
        address: {
          street: `${Math.floor(Math.random() * 1000) + 1} ${['Main', 'Park', 'Oak', 'Maple', 'Cedar'][Math.floor(Math.random() * 5)]} ${['Street', 'Avenue', 'Road', 'Boulevard', 'Lane'][Math.floor(Math.random() * 5)]}`,
          city: ['Lagos', 'Abuja', 'Port Harcourt', 'Kano', 'Ibadan', 'Kaduna', 'Enugu', 'Benin City', 'Jos', 'Owerri'][Math.floor(Math.random() * 10)],
          state: ['Lagos', 'FCT', 'Rivers', 'Kano', 'Oyo', 'Kaduna', 'Enugu', 'Edo', 'Plateau', 'Imo'][Math.floor(Math.random() * 10)],
          postalCode: `${Math.floor(Math.random() * 900) + 100}${Math.floor(Math.random() * 900) + 100}`
        },
        gender: Math.random() > 0.5 ? 'Male' : 'Female',
        dateOfBirth: new Date(now.getFullYear() - Math.floor(Math.random() * 60) - 18, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toISOString(),
        nationality: Math.random() > 0.1 ? 'Nigerian' : ['Ghanaian', 'American', 'British', 'South African', 'Kenyan', 'Canadian'][Math.floor(Math.random() * 6)],
        occupation: ['Teacher', 'Engineer', 'Doctor', 'Lawyer', 'Businessman', 'Civil Servant', 'Student', 'Farmer', 'Trader', 'Retired'][Math.floor(Math.random() * 10)],
        identificationNumber: `ID${Math.floor(Math.random() * 10000000000).toString().padStart(10, '0')}`,
        identificationType: ['National ID', 'Passport', 'Drivers License', 'Voters Card', 'Tax ID'][Math.floor(Math.random() * 5)]
      });
    }
  }
  return mockData;
};
const UserManagement: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState<any[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState('all');
  const [roleFilter, setRoleFilter] = useState('all');
  const [verificationFilter, setVerificationFilter] = useState('all');
  const [sortOrder, setSortOrder] = useState('newest');
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToEdit, setUserToEdit] = useState<any>(null);
  const [userToDelete, setUserToDelete] = useState<string>('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [userStats, setUserStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    newUsersThisMonth: 0,
    verifiedUsers: 0,
    verificationRate: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [activeTab, setActiveTab] = useState('profile');
  const {
    hasPermission,
    isSuperAdmin,
    getMdaId,
    getMdaName
  } = useAdminAuth();
  const canCreateUser = hasPermission('users:create');
  const canEditUser = hasPermission('users:edit');
  const canDeleteUser = hasPermission('users:delete');
  const canExportUsers = hasPermission('users:export');
  // Load users
  useEffect(() => {
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      let allUsers = [];
      // If super admin, load all users
      // If MDA admin, only load users for their MDA
      if (isSuperAdmin()) {
        allUsers = generateMockUsers(100);
      } else {
        const mdaName = getMdaName();
        allUsers = generateMockUsers(50, mdaName);
      }
      setUsers(allUsers);
      setFilteredUsers(allUsers);
      // Calculate user stats
      const totalUsers = allUsers.length;
      const activeUsers = allUsers.filter((u: any) => u.status === 'Active').length;
      // Calculate new users this month
      const now = new Date();
      const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const newUsersThisMonth = allUsers.filter((u: any) => new Date(u.registrationDate) >= firstDayOfMonth).length;
      // Calculate verified users (users with both email and phone verified)
      const verifiedUsers = allUsers.filter((u: any) => u.isEmailVerified && u.isPhoneVerified).length;
      const verificationRate = Math.round(verifiedUsers / totalUsers * 100);
      setUserStats({
        totalUsers,
        activeUsers,
        newUsersThisMonth,
        verifiedUsers,
        verificationRate
      });
      setIsLoading(false);
    }, 1000);
  }, [isSuperAdmin, getMdaId, getMdaName]);
  // Apply filters
  useEffect(() => {
    let filtered = [...users];
    // Apply status filter
    if (statusFilter !== 'all') {
      filtered = filtered.filter(u => u.status === statusFilter);
    }
    // Apply role filter
    if (roleFilter !== 'all') {
      filtered = filtered.filter(u => u.role === roleFilter);
    }
    // Apply verification filter
    if (verificationFilter === 'verified') {
      filtered = filtered.filter(u => u.isEmailVerified && u.isPhoneVerified);
    } else if (verificationFilter === 'unverified') {
      filtered = filtered.filter(u => !u.isEmailVerified || !u.isPhoneVerified);
    }
    // Apply search query
    if (searchQuery.trim() !== '') {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(u => u.userId.toLowerCase().includes(query) || u.firstName.toLowerCase().includes(query) || u.lastName.toLowerCase().includes(query) || u.email.toLowerCase().includes(query) || u.phone.toLowerCase().includes(query));
    }
    // Apply sort order
    filtered.sort((a, b) => {
      if (sortOrder === 'newest') {
        return new Date(b.registrationDate).getTime() - new Date(a.registrationDate).getTime();
      } else if (sortOrder === 'oldest') {
        return new Date(a.registrationDate).getTime() - new Date(b.registrationDate).getTime();
      } else if (sortOrder === 'a-z') {
        return `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
      } else if (sortOrder === 'z-a') {
        return `${b.firstName} ${b.lastName}`.localeCompare(`${a.firstName} ${a.lastName}`);
      } else if (sortOrder === 'last-active') {
        return new Date(b.lastLoginDate).getTime() - new Date(a.lastLoginDate).getTime();
      }
      return 0;
    });
    setFilteredUsers(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  }, [users, searchQuery, statusFilter, roleFilter, verificationFilter, sortOrder]);
  // Toggle sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Toggle dropdown
  const toggleDropdown = (dropdown: string) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };
  // View user details
  const viewUserDetails = (userId: string) => {
    setSelectedUser(userId);
    setActiveTab('profile');
  };
  // Edit user
  const editUser = (user: any) => {
    setUserToEdit(user);
    setShowEditModal(true);
  };
  // Delete user
  const deleteUser = (userId: string) => {
    setUserToDelete(userId);
    setShowDeleteModal(true);
  };
  // Process delete
  const processDelete = () => {
    if (!userToDelete) return;
    setIsProcessing(true);
    // Simulate API call delay
    setTimeout(() => {
      const updatedUsers = users.filter(user => user.id !== userToDelete);
      setUsers(updatedUsers);
      setShowDeleteModal(false);
      setUserToDelete('');
      setIsProcessing(false);
      // If the deleted user was selected, clear the selection
      if (selectedUser === userToDelete) {
        setSelectedUser(null);
      }
    }, 1000);
  };
  // Refresh users
  const refreshUsers = () => {
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      let allUsers = [];
      // If super admin, load all users
      // If MDA admin, only load users for their MDA
      if (isSuperAdmin()) {
        allUsers = generateMockUsers(100);
      } else {
        const mdaName = getMdaName();
        allUsers = generateMockUsers(50, mdaName);
      }
      setUsers(allUsers);
      setFilteredUsers(allUsers);
      // Calculate user stats
      const totalUsers = allUsers.length;
      const activeUsers = allUsers.filter((u: any) => u.status === 'Active').length;
      // Calculate new users this month
      const now = new Date();
      const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const newUsersThisMonth = allUsers.filter((u: any) => new Date(u.registrationDate) >= firstDayOfMonth).length;
      // Calculate verified users (users with both email and phone verified)
      const verifiedUsers = allUsers.filter((u: any) => u.isEmailVerified && u.isPhoneVerified).length;
      const verificationRate = Math.round(verifiedUsers / totalUsers * 100);
      setUserStats({
        totalUsers,
        activeUsers,
        newUsersThisMonth,
        verifiedUsers,
        verificationRate
      });
      setIsLoading(false);
      setSelectedUser(null);
    }, 1000);
  };
  // Get status badge class
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Inactive':
        return 'bg-gray-100 text-gray-800';
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'Suspended':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Get status icon
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Active':
        return <CheckCircleIcon size={16} className="text-green-600" data-id="element-4256" />;
      case 'Inactive':
        return <XCircleIcon size={16} className="text-gray-600" data-id="element-4257" />;
      case 'Pending':
        return <ClockIcon size={16} className="text-yellow-600" data-id="element-4258" />;
      case 'Suspended':
        return <AlertCircleIcon size={16} className="text-red-600" data-id="element-4259" />;
      default:
        return <InfoIcon size={16} className="text-gray-600" data-id="element-4260" />;
    }
  };
  // Format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  // Export users
  const exportUsers = () => {
    // In a real application, this would generate a CSV or Excel file
    alert('Users exported successfully');
  };
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const paginate = (pageNumber: number) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  // Change user status
  const changeUserStatus = (userId: string, newStatus: string) => {
    const updatedUsers = users.map(user => {
      if (user.id === userId) {
        return {
          ...user,
          status: newStatus
        };
      }
      return user;
    });
    setUsers(updatedUsers);
    // If the user whose status was changed is currently selected, update the selected user
    if (selectedUser === userId) {
      setSelectedUser(null);
      setTimeout(() => setSelectedUser(userId), 100);
    }
  };
  // Send verification reminder
  const sendVerificationReminder = (userId: string) => {
    alert(`Verification reminder sent to user ${userId}`);
  };
  // Reset password
  const resetPassword = (userId: string) => {
    alert(`Password reset link sent to user ${userId}`);
  };
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-100" data-id="element-4261">
        <div className="flex flex-col items-center" data-id="element-4262">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4" data-id="element-4263"></div>
          <p className="text-gray-600" data-id="element-4264">Loading user data...</p>
        </div>
      </div>;
  }
  return <div className="flex h-screen bg-gray-100" data-id="element-4265">
      {/* Sidebar - hidden on mobile unless toggled */}
      <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block fixed inset-y-0 left-0 z-50 lg:relative lg:z-0`} data-id="element-4266">
        <AdminSidebar data-id="element-4267" />
      </div>
      {/* Backdrop for mobile sidebar */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-4268"></div>}
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4269">
        <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} data-id="element-4270" />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6" data-id="element-4271">
          {/* Page Header */}
          <div className="mb-6" data-id="element-4272">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-4273">
              User Management
              {!isSuperAdmin() && <span className="ml-2 text-lg font-normal text-gray-600" data-id="element-4274">
                  ({getMdaName()})
                </span>}
            </h1>
            <p className="text-gray-600 mt-1" data-id="element-4275">
              {isSuperAdmin() ? 'Manage all platform users and their access permissions' : `Manage users associated with ${getMdaName()}`}
            </p>
          </div>
          {/* User Stats */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-4276">
            <div className="bg-white rounded-lg shadow p-4" data-id="element-4277">
              <div className="flex justify-between items-start" data-id="element-4278">
                <div data-id="element-4279">
                  <p className="text-sm font-medium text-gray-500" data-id="element-4280">
                    Total Users
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-4281">
                    {userStats.totalUsers.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-blue-100 rounded-md" data-id="element-4282">
                  <UsersIcon size={20} className="text-blue-600" data-id="element-4283" />
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-600" data-id="element-4284">
                <span data-id="element-4285">
                  {isSuperAdmin() ? 'Platform-wide' : `Associated with ${getMdaName()}`}
                </span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-4286">
              <div className="flex justify-between items-start" data-id="element-4287">
                <div data-id="element-4288">
                  <p className="text-sm font-medium text-gray-500" data-id="element-4289">
                    Active Users
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-4290">
                    {userStats.activeUsers.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-green-100 rounded-md" data-id="element-4291">
                  <UserCheckIcon size={20} className="text-green-600" data-id="element-4292" />
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-600" data-id="element-4293">
                <span data-id="element-4294">
                  {Math.round(userStats.activeUsers / userStats.totalUsers * 100)}
                  % of total users
                </span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-4295">
              <div className="flex justify-between items-start" data-id="element-4296">
                <div data-id="element-4297">
                  <p className="text-sm font-medium text-gray-500" data-id="element-4298">
                    New This Month
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-4299">
                    {userStats.newUsersThisMonth.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-purple-100 rounded-md" data-id="element-4300">
                  <UserPlusIcon size={20} className="text-purple-600" data-id="element-4301" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-green-600" data-id="element-4302">
                <ArrowUpIcon size={14} className="mr-1" data-id="element-4303" />
                <span data-id="element-4304">12% from last month</span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-4305">
              <div className="flex justify-between items-start" data-id="element-4306">
                <div data-id="element-4307">
                  <p className="text-sm font-medium text-gray-500" data-id="element-4308">
                    Verification Rate
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-4309">
                    {userStats.verificationRate}%
                  </p>
                </div>
                <div className="p-2 bg-yellow-100 rounded-md" data-id="element-4310">
                  <ShieldIcon size={20} className="text-yellow-600" data-id="element-4311" />
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-600" data-id="element-4312">
                <span data-id="element-4313">
                  {userStats.verifiedUsers.toLocaleString()} verified users
                </span>
              </div>
            </div>
          </div>
          {/* User Controls */}
          <div className="bg-white rounded-lg shadow mb-6" data-id="element-4314">
            <div className="p-4 border-b border-gray-200" data-id="element-4315">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-4316">
                {/* Search */}
                <div className="relative flex-1" data-id="element-4317">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-4318">
                    <SearchIcon size={18} className="text-gray-400" data-id="element-4319" />
                  </div>
                  <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm" placeholder="Search by name, email, phone, or ID" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-4320" />
                </div>
                {/* Filters */}
                <div className="flex flex-wrap gap-2" data-id="element-4321">
                  <div className="relative" data-id="element-4322">
                    <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={() => toggleDropdown('filter')} data-id="element-4323">
                      <FilterIcon size={18} className="mr-2" data-id="element-4324" />
                      Filters
                      <ChevronDownIcon size={18} className="ml-2" data-id="element-4325" />
                    </button>
                    {activeDropdown === 'filter' && <div className="origin-top-right absolute right-0 mt-2 w-72 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-4326">
                        <div className="py-1 p-3" data-id="element-4327">
                          <div className="mb-3" data-id="element-4328">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4329">
                              Status
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-4330">
                              <option value="all" data-id="element-4331">All Statuses</option>
                              <option value="Active" data-id="element-4332">Active</option>
                              <option value="Inactive" data-id="element-4333">Inactive</option>
                              <option value="Pending" data-id="element-4334">Pending</option>
                              <option value="Suspended" data-id="element-4335">Suspended</option>
                            </select>
                          </div>
                          <div className="mb-3" data-id="element-4336">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4337">
                              Role
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={roleFilter} onChange={e => setRoleFilter(e.target.value)} data-id="element-4338">
                              <option value="all" data-id="element-4339">All Roles</option>
                              <option value="Citizen" data-id="element-4340">Citizen</option>
                              <option value="Business Owner" data-id="element-4341">
                                Business Owner
                              </option>
                              <option value="Government Employee" data-id="element-4342">
                                Government Employee
                              </option>
                              <option value="Foreigner" data-id="element-4343">Foreigner</option>
                              <option value="NGO Representative" data-id="element-4344">
                                NGO Representative
                              </option>
                            </select>
                          </div>
                          <div className="mb-3" data-id="element-4345">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4346">
                              Verification
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={verificationFilter} onChange={e => setVerificationFilter(e.target.value)} data-id="element-4347">
                              <option value="all" data-id="element-4348">All Users</option>
                              <option value="verified" data-id="element-4349">Verified Users</option>
                              <option value="unverified" data-id="element-4350">
                                Unverified Users
                              </option>
                            </select>
                          </div>
                          <div className="mb-3" data-id="element-4351">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4352">
                              Sort By
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={sortOrder} onChange={e => setSortOrder(e.target.value)} data-id="element-4353">
                              <option value="newest" data-id="element-4354">Newest First</option>
                              <option value="oldest" data-id="element-4355">Oldest First</option>
                              <option value="a-z" data-id="element-4356">A-Z</option>
                              <option value="z-a" data-id="element-4357">Z-A</option>
                              <option value="last-active" data-id="element-4358">Last Active</option>
                            </select>
                          </div>
                          <div className="flex justify-between pt-2" data-id="element-4359">
                            <button className="text-sm text-gray-700 hover:text-gray-900" onClick={() => {
                          setStatusFilter('all');
                          setRoleFilter('all');
                          setVerificationFilter('all');
                          setSortOrder('newest');
                        }} data-id="element-4360">
                              Reset Filters
                            </button>
                            <button className="bg-green-600 text-white px-3 py-1 rounded-md text-sm hover:bg-green-700" onClick={() => setActiveDropdown(null)} data-id="element-4361">
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>}
                  </div>
                  <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={refreshUsers} disabled={isLoading} data-id="element-4362">
                    <RefreshCwIcon size={18} className={`mr-2 ${isLoading ? 'animate-spin' : ''}`} data-id="element-4363" />
                    Refresh
                  </button>
                  {canExportUsers && <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={exportUsers} data-id="element-4364">
                      <DownloadIcon size={18} className="mr-2" data-id="element-4365" />
                      Export
                    </button>}
                  {canCreateUser && <button className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700" onClick={() => setShowCreateModal(true)} data-id="element-4366">
                      <PlusIcon size={18} className="mr-2" data-id="element-4367" />
                      Add User
                    </button>}
                </div>
              </div>
            </div>
          </div>
          {/* User Content */}
          <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-4368">
            {filteredUsers.length === 0 ? <div className="p-8 text-center" data-id="element-4369">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-4370">
                  <UsersIcon size={24} className="text-gray-400" data-id="element-4371" />
                </div>
                <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-4372">
                  No users found
                </h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-4373">
                  {searchQuery ? 'Try adjusting your search or filter criteria.' : 'There are no users matching your current filters.'}
                </p>
                <div className="mt-6" data-id="element-4374">
                  <button type="button" className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" onClick={refreshUsers} data-id="element-4375">
                    <RefreshCwIcon size={16} className="mr-2" data-id="element-4376" />
                    Refresh
                  </button>
                </div>
              </div> : <div className="flex flex-col md:flex-row h-full" data-id="element-4377">
                {/* User List */}
                <div className={`w-full md:w-1/2 lg:w-2/3 ${selectedUser ? 'hidden md:block' : ''}`} data-id="element-4378">
                  <div className="overflow-x-auto" data-id="element-4379">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-4380">
                      <thead className="bg-gray-50" data-id="element-4381">
                        <tr data-id="element-4382">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4383">
                            User
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4384">
                            Status
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4385">
                            Role
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4386">
                            Registered
                          </th>
                          {isSuperAdmin() && <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4387">
                              MDAs
                            </th>}
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4388">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-4389">
                        {currentItems.map(user => <tr key={user.id} className={`hover:bg-gray-50 cursor-pointer ${selectedUser === user.id ? 'bg-green-50' : ''}`} onClick={() => viewUserDetails(user.id)} data-id="element-4390">
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-4391">
                              <div className="flex items-center" data-id="element-4392">
                                <div className="flex-shrink-0 h-10 w-10 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-4393">
                                  <UserIcon className="h-6 w-6 text-gray-500" data-id="element-4394" />
                                </div>
                                <div className="ml-4" data-id="element-4395">
                                  <div className="text-sm font-medium text-gray-900" data-id="element-4396">
                                    {user.firstName} {user.lastName}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-4397">
                                    {user.email}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-4398">
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeClass(user.status)}`} data-id="element-4399">
                                {getStatusIcon(user.status)}
                                <span className="ml-1" data-id="element-4400">{user.status}</span>
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-4401">
                              {user.role}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-4402">
                              {formatDate(user.registrationDate)}
                            </td>
                            {isSuperAdmin() && <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-4403">
                                {user.mdas.length > 0 ? <div className="flex flex-wrap gap-1" data-id="element-4404">
                                    {user.mdas.map((mda: string, index: number) => <span key={index} className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded" data-id="element-4405">
                                          {mda.split(' ').map((word: string) => word[0]).join('')}
                                        </span>)}
                                  </div> : <span className="text-gray-400" data-id="element-4406">None</span>}
                              </td>}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-4407">
                              <div className="flex space-x-2" data-id="element-4408">
                                <button onClick={e => {
                            e.stopPropagation();
                            viewUserDetails(user.id);
                          }} className="text-blue-600 hover:text-blue-900" data-id="element-4409">
                                  <EyeIcon size={16} data-id="element-4410" />
                                </button>
                                {canEditUser && <button onClick={e => {
                            e.stopPropagation();
                            editUser(user);
                          }} className="text-green-600 hover:text-green-900" data-id="element-4411">
                                    <EditIcon size={16} data-id="element-4412" />
                                  </button>}
                                {canDeleteUser && <button onClick={e => {
                            e.stopPropagation();
                            deleteUser(user.id);
                          }} className="text-red-600 hover:text-red-900" data-id="element-4413">
                                    <TrashIcon size={16} data-id="element-4414" />
                                  </button>}
                              </div>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination */}
                  <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-4415">
                    <div className="flex-1 flex justify-between sm:hidden" data-id="element-4416">
                      <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-4417">
                        Previous
                      </button>
                      <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-4418">
                        Next
                      </button>
                    </div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-4419">
                      <div data-id="element-4420">
                        <p className="text-sm text-gray-700" data-id="element-4421">
                          Showing{' '}
                          <span className="font-medium" data-id="element-4422">
                            {indexOfFirstItem + 1}
                          </span>{' '}
                          to{' '}
                          <span className="font-medium" data-id="element-4423">
                            {Math.min(indexOfLastItem, filteredUsers.length)}
                          </span>{' '}
                          of{' '}
                          <span className="font-medium" data-id="element-4424">
                            {filteredUsers.length}
                          </span>{' '}
                          results
                        </p>
                      </div>
                      <div data-id="element-4425">
                        <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-4426">
                          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-500 hover:bg-gray-50'}`} data-id="element-4427">
                            <span className="sr-only" data-id="element-4428">Previous</span>
                            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-4429" />
                          </button>
                          {/* Page numbers */}
                          {Array.from({
                        length: Math.min(5, totalPages)
                      }, (_, i) => {
                        let pageNumber: number;
                        if (totalPages <= 5) {
                          pageNumber = i + 1;
                        } else if (currentPage <= 3) {
                          pageNumber = i + 1;
                        } else if (currentPage >= totalPages - 2) {
                          pageNumber = totalPages - 4 + i;
                        } else {
                          pageNumber = currentPage - 2 + i;
                        }
                        return <button key={pageNumber} onClick={() => paginate(pageNumber)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${currentPage === pageNumber ? 'z-10 bg-green-50 border-green-500 text-green-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} data-id="element-4430">
                                  {pageNumber}
                                </button>;
                      })}
                          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-500 hover:bg-gray-50'}`} data-id="element-4431">
                            <span className="sr-only" data-id="element-4432">Next</span>
                            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-4433" />
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
                {/* User Detail */}
                {selectedUser ? <div className="w-full md:w-1/2 lg:w-1/3 border-l border-gray-200 flex flex-col" data-id="element-4434">
                    {users.filter(u => u.id === selectedUser).map(user => <div key={user.id} className="flex flex-col h-full" data-id="element-4435">
                          {/* User Header */}
                          <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-4436">
                            <div className="flex items-center justify-between mb-2" data-id="element-4437">
                              <button className="md:hidden flex items-center text-gray-500 hover:text-gray-700" onClick={() => setSelectedUser(null)} data-id="element-4438">
                                <ArrowLeftIcon size={16} className="mr-1" data-id="element-4439" />
                                Back
                              </button>
                              <div className="flex space-x-2" data-id="element-4440">
                                {canEditUser && <button onClick={() => editUser(user)} className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-md hover:bg-blue-100" data-id="element-4441">
                                    <EditIcon size={14} className="inline mr-1" data-id="element-4442" />
                                    Edit
                                  </button>}
                                <div className="relative" data-id="element-4443">
                                  <button onClick={() => toggleDropdown('userActions')} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-4444">
                                    <MoreHorizontalIcon size={14} data-id="element-4445" />
                                  </button>
                                  {activeDropdown === 'userActions' && <div className="absolute right-0 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-4446">
                                      <div className="py-1" data-id="element-4447">
                                        {user.status === 'Active' ? <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                              toggleDropdown('userActions');
                              changeUserStatus(user.id, 'Suspended');
                            }} data-id="element-4448">
                                            Suspend User
                                          </button> : user.status === 'Suspended' ? <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                              toggleDropdown('userActions');
                              changeUserStatus(user.id, 'Active');
                            }} data-id="element-4449">
                                            Reactivate User
                                          </button> : null}
                                        <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                              toggleDropdown('userActions');
                              resetPassword(user.id);
                            }} data-id="element-4450">
                                          Reset Password
                                        </button>
                                        {(!user.isEmailVerified || !user.isPhoneVerified) && <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                              toggleDropdown('userActions');
                              sendVerificationReminder(user.id);
                            }} data-id="element-4451">
                                            Send Verification Reminder
                                          </button>}
                                        {canDeleteUser && <button className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50" onClick={() => {
                              toggleDropdown('userActions');
                              deleteUser(user.id);
                            }} data-id="element-4452">
                                            Delete User
                                          </button>}
                                      </div>
                                    </div>}
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center" data-id="element-4453">
                              <div className="flex-shrink-0 h-16 w-16 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-4454">
                                <UserIcon className="h-8 w-8 text-gray-500" data-id="element-4455" />
                              </div>
                              <div className="ml-4" data-id="element-4456">
                                <h2 className="text-lg font-medium text-gray-900" data-id="element-4457">
                                  {user.firstName} {user.lastName}
                                </h2>
                                <div className="flex items-center mt-1" data-id="element-4458">
                                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeClass(user.status)}`} data-id="element-4459">
                                    {getStatusIcon(user.status)}
                                    <span className="ml-1" data-id="element-4460">{user.status}</span>
                                  </span>
                                  <span className="ml-2 text-sm text-gray-500" data-id="element-4461">
                                    {user.userId}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* User Tabs */}
                          <div className="border-b border-gray-200" data-id="element-4462">
                            <nav className="flex -mb-px" data-id="element-4463">
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'profile' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('profile')} data-id="element-4464">
                                Profile
                              </button>
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'activity' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('activity')} data-id="element-4465">
                                Activity
                              </button>
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'services' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('services')} data-id="element-4466">
                                Services
                              </button>
                            </nav>
                          </div>
                          {/* User Content */}
                          <div className="flex-1 overflow-y-auto p-4" data-id="element-4467">
                            {activeTab === 'profile' && <div className="space-y-6" data-id="element-4468">
                                <div data-id="element-4469">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4470">
                                    Basic Information
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4471">
                                    <div className="flex justify-between" data-id="element-4472">
                                      <span className="text-sm text-gray-600" data-id="element-4473">
                                        Full Name
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4474">
                                        {user.firstName} {user.lastName}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4475">
                                      <span className="text-sm text-gray-600" data-id="element-4476">
                                        User ID
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4477">
                                        {user.userId}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4478">
                                      <span className="text-sm text-gray-600" data-id="element-4479">
                                        Role
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4480">
                                        {user.role}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4481">
                                      <span className="text-sm text-gray-600" data-id="element-4482">
                                        Registration Date
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4483">
                                        {formatDate(user.registrationDate)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-4484">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4485">
                                    Contact Information
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4486">
                                    <div className="flex justify-between items-center" data-id="element-4487">
                                      <span className="text-sm text-gray-600" data-id="element-4488">
                                        Email
                                      </span>
                                      <div className="flex items-center" data-id="element-4489">
                                        <span className="text-sm font-medium text-gray-900 mr-2" data-id="element-4490">
                                          {user.email}
                                        </span>
                                        {user.isEmailVerified ? <CheckCircleIcon size={16} className="text-green-600" data-id="element-4491" /> : <AlertCircleIcon size={16} className="text-yellow-600" data-id="element-4492" />}
                                      </div>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-4493">
                                      <span className="text-sm text-gray-600" data-id="element-4494">
                                        Phone
                                      </span>
                                      <div className="flex items-center" data-id="element-4495">
                                        <span className="text-sm font-medium text-gray-900 mr-2" data-id="element-4496">
                                          {user.phone}
                                        </span>
                                        {user.isPhoneVerified ? <CheckCircleIcon size={16} className="text-green-600" data-id="element-4497" /> : <AlertCircleIcon size={16} className="text-yellow-600" data-id="element-4498" />}
                                      </div>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4499">
                                      <span className="text-sm text-gray-600" data-id="element-4500">
                                        Address
                                      </span>
                                      <span className="text-sm font-medium text-gray-900 text-right" data-id="element-4501">
                                        {user.address.street},{' '}
                                        {user.address.city},{' '}
                                        {user.address.state}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-4502">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4503">
                                    Personal Information
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4504">
                                    <div className="flex justify-between" data-id="element-4505">
                                      <span className="text-sm text-gray-600" data-id="element-4506">
                                        Gender
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4507">
                                        {user.gender}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4508">
                                      <span className="text-sm text-gray-600" data-id="element-4509">
                                        Date of Birth
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4510">
                                        {formatDate(user.dateOfBirth)}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4511">
                                      <span className="text-sm text-gray-600" data-id="element-4512">
                                        Nationality
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4513">
                                        {user.nationality}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4514">
                                      <span className="text-sm text-gray-600" data-id="element-4515">
                                        Occupation
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4516">
                                        {user.occupation}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-4517">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4518">
                                    Identification
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4519">
                                    <div className="flex justify-between items-center" data-id="element-4520">
                                      <span className="text-sm text-gray-600" data-id="element-4521">
                                        ID Type
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4522">
                                        {user.identificationType}
                                      </span>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-4523">
                                      <span className="text-sm text-gray-600" data-id="element-4524">
                                        ID Number
                                      </span>
                                      <div className="flex items-center" data-id="element-4525">
                                        <span className="text-sm font-medium text-gray-900 mr-2" data-id="element-4526">
                                          {user.identificationNumber}
                                        </span>
                                        {user.isIdVerified ? <CheckCircleIcon size={16} className="text-green-600" data-id="element-4527" /> : <AlertCircleIcon size={16} className="text-yellow-600" data-id="element-4528" />}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {isSuperAdmin() && <div data-id="element-4529">
                                    <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4530">
                                      MDA Associations
                                    </h3>
                                    <div className="bg-gray-50 rounded-lg p-3" data-id="element-4531">
                                      {user.mdas.length > 0 ? <div className="space-y-2" data-id="element-4532">
                                          {user.mdas.map((mda: string, index: number) => <div key={index} className="flex items-center px-3 py-2 bg-white rounded-md" data-id="element-4533">
                                                <BuildingIcon size={16} className="text-gray-500 mr-2" data-id="element-4534" />
                                                <span className="text-sm text-gray-900" data-id="element-4535">
                                                  {mda}
                                                </span>
                                              </div>)}
                                        </div> : <p className="text-sm text-gray-500" data-id="element-4536">
                                          No MDA associations
                                        </p>}
                                    </div>
                                  </div>}
                              </div>}
                            {activeTab === 'activity' && <div className="space-y-6" data-id="element-4537">
                                <div data-id="element-4538">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4539">
                                    Account Activity
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4540">
                                    <div className="flex justify-between" data-id="element-4541">
                                      <span className="text-sm text-gray-600" data-id="element-4542">
                                        Last Login
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4543">
                                        {formatDate(user.lastLoginDate)}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4544">
                                      <span className="text-sm text-gray-600" data-id="element-4545">
                                        Applications
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4546">
                                        {user.applicationCount}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4547">
                                      <span className="text-sm text-gray-600" data-id="element-4548">
                                        Payments
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4549">
                                        {user.paymentCount}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4550">
                                      <span className="text-sm text-gray-600" data-id="element-4551">
                                        Completed Services
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4552">
                                        {user.completedServiceCount}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-4553">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4554">
                                    Recent Activity
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3" data-id="element-4555">
                                    <div className="space-y-3" data-id="element-4556">
                                      <div className="flex items-start" data-id="element-4557">
                                        <div className="min-w-0 flex-1" data-id="element-4558">
                                          <p className="text-sm text-gray-900" data-id="element-4559">
                                            <span className="font-medium" data-id="element-4560">
                                              Login
                                            </span>
                                          </p>
                                          <p className="text-xs text-gray-500" data-id="element-4561">
                                            {formatDate(user.lastLoginDate)}
                                          </p>
                                        </div>
                                        <div className="flex-shrink-0 bg-blue-100 rounded-full p-1" data-id="element-4562">
                                          <LockIcon size={14} className="text-blue-600" data-id="element-4563" />
                                        </div>
                                      </div>
                                      {user.paymentCount > 0 && <div className="flex items-start" data-id="element-4564">
                                          <div className="min-w-0 flex-1" data-id="element-4565">
                                            <p className="text-sm text-gray-900" data-id="element-4566">
                                              <span className="font-medium" data-id="element-4567">
                                                Payment
                                              </span>{' '}
                                              for Business Registration
                                            </p>
                                            <p className="text-xs text-gray-500" data-id="element-4568">
                                              3 days ago
                                            </p>
                                          </div>
                                          <div className="flex-shrink-0 bg-green-100 rounded-full p-1" data-id="element-4569">
                                            <CreditCardIcon size={14} className="text-green-600" data-id="element-4570" />
                                          </div>
                                        </div>}
                                      {user.applicationCount > 0 && <div className="flex items-start" data-id="element-4571">
                                          <div className="min-w-0 flex-1" data-id="element-4572">
                                            <p className="text-sm text-gray-900" data-id="element-4573">
                                              <span className="font-medium" data-id="element-4574">
                                                Application
                                              </span>{' '}
                                              for Tax Clearance Certificate
                                            </p>
                                            <p className="text-xs text-gray-500" data-id="element-4575">
                                              1 week ago
                                            </p>
                                          </div>
                                          <div className="flex-shrink-0 bg-purple-100 rounded-full p-1" data-id="element-4576">
                                            <FileTextIcon size={14} className="text-purple-600" data-id="element-4577" />
                                          </div>
                                        </div>}
                                      <div className="flex items-start" data-id="element-4578">
                                        <div className="min-w-0 flex-1" data-id="element-4579">
                                          <p className="text-sm text-gray-900" data-id="element-4580">
                                            <span className="font-medium" data-id="element-4581">
                                              Profile Update
                                            </span>
                                          </p>
                                          <p className="text-xs text-gray-500" data-id="element-4582">
                                            2 weeks ago
                                          </p>
                                        </div>
                                        <div className="flex-shrink-0 bg-yellow-100 rounded-full p-1" data-id="element-4583">
                                          <UserIcon size={14} className="text-yellow-600" data-id="element-4584" />
                                        </div>
                                      </div>
                                      <div className="flex items-start" data-id="element-4585">
                                        <div className="min-w-0 flex-1" data-id="element-4586">
                                          <p className="text-sm text-gray-900" data-id="element-4587">
                                            <span className="font-medium" data-id="element-4588">
                                              Account Created
                                            </span>
                                          </p>
                                          <p className="text-xs text-gray-500" data-id="element-4589">
                                            {formatDate(user.registrationDate)}
                                          </p>
                                        </div>
                                        <div className="flex-shrink-0 bg-green-100 rounded-full p-1" data-id="element-4590">
                                          <UserPlusIcon size={14} className="text-green-600" data-id="element-4591" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-4592">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4593">
                                    Security & Access
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4594">
                                    <div className="flex justify-between items-center" data-id="element-4595">
                                      <span className="text-sm text-gray-600" data-id="element-4596">
                                        Email Verification
                                      </span>
                                      <div className="flex items-center" data-id="element-4597">
                                        {user.isEmailVerified ? <>
                                            <CheckCircleIcon size={16} className="text-green-600 mr-1" data-id="element-4598" />
                                            <span className="text-sm text-green-600" data-id="element-4599">
                                              Verified
                                            </span>
                                          </> : <>
                                            <AlertCircleIcon size={16} className="text-yellow-600 mr-1" data-id="element-4600" />
                                            <span className="text-sm text-yellow-600" data-id="element-4601">
                                              Pending
                                            </span>
                                          </>}
                                      </div>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-4602">
                                      <span className="text-sm text-gray-600" data-id="element-4603">
                                        Phone Verification
                                      </span>
                                      <div className="flex items-center" data-id="element-4604">
                                        {user.isPhoneVerified ? <>
                                            <CheckCircleIcon size={16} className="text-green-600 mr-1" data-id="element-4605" />
                                            <span className="text-sm text-green-600" data-id="element-4606">
                                              Verified
                                            </span>
                                          </> : <>
                                            <AlertCircleIcon size={16} className="text-yellow-600 mr-1" data-id="element-4607" />
                                            <span className="text-sm text-yellow-600" data-id="element-4608">
                                              Pending
                                            </span>
                                          </>}
                                      </div>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-4609">
                                      <span className="text-sm text-gray-600" data-id="element-4610">
                                        ID Verification
                                      </span>
                                      <div className="flex items-center" data-id="element-4611">
                                        {user.isIdVerified ? <>
                                            <CheckCircleIcon size={16} className="text-green-600 mr-1" data-id="element-4612" />
                                            <span className="text-sm text-green-600" data-id="element-4613">
                                              Verified
                                            </span>
                                          </> : <>
                                            <AlertCircleIcon size={16} className="text-yellow-600 mr-1" data-id="element-4614" />
                                            <span className="text-sm text-yellow-600" data-id="element-4615">
                                              Pending
                                            </span>
                                          </>}
                                      </div>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-4616">
                                      <span className="text-sm text-gray-600" data-id="element-4617">
                                        Account Status
                                      </span>
                                      <div className="flex items-center" data-id="element-4618">
                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeClass(user.status)}`} data-id="element-4619">
                                          {getStatusIcon(user.status)}
                                          <span className="ml-1" data-id="element-4620">
                                            {user.status}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>}
                            {activeTab === 'services' && <div className="space-y-6" data-id="element-4621">
                                <div data-id="element-4622">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4623">
                                    Service Usage
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-4624">
                                    <div className="flex justify-between" data-id="element-4625">
                                      <span className="text-sm text-gray-600" data-id="element-4626">
                                        Total Applications
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4627">
                                        {user.applicationCount}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4628">
                                      <span className="text-sm text-gray-600" data-id="element-4629">
                                        Completed Services
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4630">
                                        {user.completedServiceCount}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-4631">
                                      <span className="text-sm text-gray-600" data-id="element-4632">
                                        Pending Services
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-4633">
                                        {user.applicationCount - user.completedServiceCount}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-4634">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4635">
                                    Recent Applications
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3" data-id="element-4636">
                                    {user.applicationCount > 0 ? <div className="space-y-3" data-id="element-4637">
                                        <div className="px-3 py-2 bg-white rounded-md" data-id="element-4638">
                                          <div className="flex justify-between items-center" data-id="element-4639">
                                            <div data-id="element-4640">
                                              <p className="text-sm font-medium text-gray-900" data-id="element-4641">
                                                Business Registration
                                              </p>
                                              <p className="text-xs text-gray-500" data-id="element-4642">
                                                Ministry of Commerce and
                                                Industry
                                              </p>
                                            </div>
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-4643">
                                              <ClockIcon size={12} className="mr-1" data-id="element-4644" />
                                              Pending
                                            </span>
                                          </div>
                                          <p className="text-xs text-gray-500 mt-1" data-id="element-4645">
                                            Applied 3 days ago
                                          </p>
                                        </div>
                                        <div className="px-3 py-2 bg-white rounded-md" data-id="element-4646">
                                          <div className="flex justify-between items-center" data-id="element-4647">
                                            <div data-id="element-4648">
                                              <p className="text-sm font-medium text-gray-900" data-id="element-4649">
                                                Tax Clearance Certificate
                                              </p>
                                              <p className="text-xs text-gray-500" data-id="element-4650">
                                                Ministry of Finance
                                              </p>
                                            </div>
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-4651">
                                              <CheckCircleIcon size={12} className="mr-1" data-id="element-4652" />
                                              Completed
                                            </span>
                                          </div>
                                          <p className="text-xs text-gray-500 mt-1" data-id="element-4653">
                                            Applied 2 weeks ago
                                          </p>
                                        </div>
                                        {user.applicationCount > 2 && <div className="px-3 py-2 bg-white rounded-md" data-id="element-4654">
                                            <div className="flex justify-between items-center" data-id="element-4655">
                                              <div data-id="element-4656">
                                                <p className="text-sm font-medium text-gray-900" data-id="element-4657">
                                                  Driver's License Renewal
                                                </p>
                                                <p className="text-xs text-gray-500" data-id="element-4658">
                                                  Federal Road Safety Commission
                                                </p>
                                              </div>
                                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-4659">
                                                <CheckCircleIcon size={12} className="mr-1" data-id="element-4660" />
                                                Completed
                                              </span>
                                            </div>
                                            <p className="text-xs text-gray-500 mt-1" data-id="element-4661">
                                              Applied 1 month ago
                                            </p>
                                          </div>}
                                        <button className="w-full text-sm text-center text-green-600 hover:text-green-800 mt-2" data-id="element-4662">
                                          View All Applications
                                        </button>
                                      </div> : <p className="text-sm text-gray-500" data-id="element-4663">
                                        No applications found
                                      </p>}
                                  </div>
                                </div>
                                <div data-id="element-4664">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4665">
                                    Payment History
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3" data-id="element-4666">
                                    {user.paymentCount > 0 ? <div className="space-y-3" data-id="element-4667">
                                        <div className="px-3 py-2 bg-white rounded-md" data-id="element-4668">
                                          <div className="flex justify-between items-center" data-id="element-4669">
                                            <div data-id="element-4670">
                                              <p className="text-sm font-medium text-gray-900" data-id="element-4671">
                                                Business Registration
                                              </p>
                                              <p className="text-xs text-gray-500" data-id="element-4672">
                                                TRX-123456
                                              </p>
                                            </div>
                                            <p className="text-sm font-medium text-gray-900" data-id="element-4673">
                                              ₦15,000
                                            </p>
                                          </div>
                                          <div className="flex justify-between mt-1" data-id="element-4674">
                                            <p className="text-xs text-gray-500" data-id="element-4675">
                                              3 days ago
                                            </p>
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-4676">
                                              <CheckCircleIcon size={12} className="mr-1" data-id="element-4677" />
                                              Successful
                                            </span>
                                          </div>
                                        </div>
                                        <div className="px-3 py-2 bg-white rounded-md" data-id="element-4678">
                                          <div className="flex justify-between items-center" data-id="element-4679">
                                            <div data-id="element-4680">
                                              <p className="text-sm font-medium text-gray-900" data-id="element-4681">
                                                Tax Clearance Certificate
                                              </p>
                                              <p className="text-xs text-gray-500" data-id="element-4682">
                                                TRX-789012
                                              </p>
                                            </div>
                                            <p className="text-sm font-medium text-gray-900" data-id="element-4683">
                                              ₦5,000
                                            </p>
                                          </div>
                                          <div className="flex justify-between mt-1" data-id="element-4684">
                                            <p className="text-xs text-gray-500" data-id="element-4685">
                                              2 weeks ago
                                            </p>
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-4686">
                                              <CheckCircleIcon size={12} className="mr-1" data-id="element-4687" />
                                              Successful
                                            </span>
                                          </div>
                                        </div>
                                        <button className="w-full text-sm text-center text-green-600 hover:text-green-800 mt-2" data-id="element-4688">
                                          View All Payments
                                        </button>
                                      </div> : <p className="text-sm text-gray-500" data-id="element-4689">
                                        No payment history found
                                      </p>}
                                  </div>
                                </div>
                              </div>}
                          </div>
                          {/* User Actions */}
                          <div className="p-4 border-t border-gray-200 bg-gray-50" data-id="element-4690">
                            <div className="flex flex-wrap gap-2" data-id="element-4691">
                              {user.status === 'Active' ? <button onClick={() => changeUserStatus(user.id, 'Suspended')} className="flex-1 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-yellow-600 hover:bg-yellow-700" data-id="element-4692">
                                  <LockIcon size={16} className="mr-2" data-id="element-4693" />
                                  Suspend User
                                </button> : user.status === 'Suspended' ? <button onClick={() => changeUserStatus(user.id, 'Active')} className="flex-1 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700" data-id="element-4694">
                                  <UnlockIcon size={16} className="mr-2" data-id="element-4695" />
                                  Reactivate User
                                </button> : null}
                              <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={() => resetPassword(user.id)} data-id="element-4696">
                                <KeyIcon size={16} className="mr-2" data-id="element-4697" />
                                Reset Password
                              </button>
                              {(!user.isEmailVerified || !user.isPhoneVerified) && <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={() => sendVerificationReminder(user.id)} data-id="element-4698">
                                  <SendIcon size={16} className="mr-2" data-id="element-4699" />
                                  Send Verification
                                </button>}
                            </div>
                          </div>
                        </div>)}
                  </div> : <div className="hidden md:flex md:w-1/2 lg:w-1/3 border-l border-gray-200 items-center justify-center p-8 bg-gray-50" data-id="element-4700">
                    <div className="text-center" data-id="element-4701">
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-4702">
                        <UserIcon size={24} className="text-gray-400" data-id="element-4703" />
                      </div>
                      <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-4704">
                        No user selected
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-4705">
                        Select a user from the list to view details.
                      </p>
                    </div>
                  </div>}
              </div>}
          </div>
          {/* User Demographics */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-4706">
            <div className="bg-white rounded-lg shadow p-4" data-id="element-4707">
              <div className="flex justify-between items-center mb-4" data-id="element-4708">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-4709">
                  User Demographics
                </h3>
                <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-4710">
                  <InfoIcon size={14} data-id="element-4711" />
                </button>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-4712">
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4713">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4714">
                    Age Distribution
                  </h4>
                  <div className="space-y-2" data-id="element-4715">
                    <div data-id="element-4716">
                      <div className="flex justify-between text-xs" data-id="element-4717">
                        <span className="text-gray-600" data-id="element-4718">18-24</span>
                        <span className="font-medium text-gray-900" data-id="element-4719">15%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4720">
                        <div className="h-1.5 rounded-full bg-blue-600" style={{
                        width: '15%'
                      }} data-id="element-4721"></div>
                      </div>
                    </div>
                    <div data-id="element-4722">
                      <div className="flex justify-between text-xs" data-id="element-4723">
                        <span className="text-gray-600" data-id="element-4724">25-34</span>
                        <span className="font-medium text-gray-900" data-id="element-4725">35%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4726">
                        <div className="h-1.5 rounded-full bg-blue-600" style={{
                        width: '35%'
                      }} data-id="element-4727"></div>
                      </div>
                    </div>
                    <div data-id="element-4728">
                      <div className="flex justify-between text-xs" data-id="element-4729">
                        <span className="text-gray-600" data-id="element-4730">35-44</span>
                        <span className="font-medium text-gray-900" data-id="element-4731">25%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4732">
                        <div className="h-1.5 rounded-full bg-blue-600" style={{
                        width: '25%'
                      }} data-id="element-4733"></div>
                      </div>
                    </div>
                    <div data-id="element-4734">
                      <div className="flex justify-between text-xs" data-id="element-4735">
                        <span className="text-gray-600" data-id="element-4736">45-54</span>
                        <span className="font-medium text-gray-900" data-id="element-4737">15%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4738">
                        <div className="h-1.5 rounded-full bg-blue-600" style={{
                        width: '15%'
                      }} data-id="element-4739"></div>
                      </div>
                    </div>
                    <div data-id="element-4740">
                      <div className="flex justify-between text-xs" data-id="element-4741">
                        <span className="text-gray-600" data-id="element-4742">55+</span>
                        <span className="font-medium text-gray-900" data-id="element-4743">10%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4744">
                        <div className="h-1.5 rounded-full bg-blue-600" style={{
                        width: '10%'
                      }} data-id="element-4745"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4746">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4747">
                    User Types
                  </h4>
                  <div className="space-y-2" data-id="element-4748">
                    <div data-id="element-4749">
                      <div className="flex justify-between text-xs" data-id="element-4750">
                        <span className="text-gray-600" data-id="element-4751">Citizen</span>
                        <span className="font-medium text-gray-900" data-id="element-4752">60%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4753">
                        <div className="h-1.5 rounded-full bg-green-600" style={{
                        width: '60%'
                      }} data-id="element-4754"></div>
                      </div>
                    </div>
                    <div data-id="element-4755">
                      <div className="flex justify-between text-xs" data-id="element-4756">
                        <span className="text-gray-600" data-id="element-4757">Business Owner</span>
                        <span className="font-medium text-gray-900" data-id="element-4758">25%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4759">
                        <div className="h-1.5 rounded-full bg-green-600" style={{
                        width: '25%'
                      }} data-id="element-4760"></div>
                      </div>
                    </div>
                    <div data-id="element-4761">
                      <div className="flex justify-between text-xs" data-id="element-4762">
                        <span className="text-gray-600" data-id="element-4763">
                          Government Employee
                        </span>
                        <span className="font-medium text-gray-900" data-id="element-4764">8%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4765">
                        <div className="h-1.5 rounded-full bg-green-600" style={{
                        width: '8%'
                      }} data-id="element-4766"></div>
                      </div>
                    </div>
                    <div data-id="element-4767">
                      <div className="flex justify-between text-xs" data-id="element-4768">
                        <span className="text-gray-600" data-id="element-4769">Foreigner</span>
                        <span className="font-medium text-gray-900" data-id="element-4770">5%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4771">
                        <div className="h-1.5 rounded-full bg-green-600" style={{
                        width: '5%'
                      }} data-id="element-4772"></div>
                      </div>
                    </div>
                    <div data-id="element-4773">
                      <div className="flex justify-between text-xs" data-id="element-4774">
                        <span className="text-gray-600" data-id="element-4775">
                          NGO Representative
                        </span>
                        <span className="font-medium text-gray-900" data-id="element-4776">2%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4777">
                        <div className="h-1.5 rounded-full bg-green-600" style={{
                        width: '2%'
                      }} data-id="element-4778"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4" data-id="element-4779">
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4780">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4781">
                    Gender Distribution
                  </h4>
                  <div className="flex items-center" data-id="element-4782">
                    <div className="w-1/2 text-center" data-id="element-4783">
                      <div className="mx-auto w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mb-1" data-id="element-4784">
                        <span className="text-blue-600 text-xs font-medium" data-id="element-4785">
                          M
                        </span>
                      </div>
                      <p className="text-xs text-gray-600" data-id="element-4786">Male</p>
                      <p className="text-sm font-medium text-gray-900" data-id="element-4787">52%</p>
                    </div>
                    <div className="w-1/2 text-center" data-id="element-4788">
                      <div className="mx-auto w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center mb-1" data-id="element-4789">
                        <span className="text-pink-600 text-xs font-medium" data-id="element-4790">
                          F
                        </span>
                      </div>
                      <p className="text-xs text-gray-600" data-id="element-4791">Female</p>
                      <p className="text-sm font-medium text-gray-900" data-id="element-4792">48%</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4793">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4794">
                    Verification Status
                  </h4>
                  <div className="flex items-center" data-id="element-4795">
                    <div className="w-1/2 text-center" data-id="element-4796">
                      <div className="mx-auto w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mb-1" data-id="element-4797">
                        <CheckIcon size={16} className="text-green-600" data-id="element-4798" />
                      </div>
                      <p className="text-xs text-gray-600" data-id="element-4799">Verified</p>
                      <p className="text-sm font-medium text-gray-900" data-id="element-4800">
                        {userStats.verificationRate}%
                      </p>
                    </div>
                    <div className="w-1/2 text-center" data-id="element-4801">
                      <div className="mx-auto w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center mb-1" data-id="element-4802">
                        <AlertCircleIcon size={16} className="text-yellow-600" data-id="element-4803" />
                      </div>
                      <p className="text-xs text-gray-600" data-id="element-4804">Unverified</p>
                      <p className="text-sm font-medium text-gray-900" data-id="element-4805">
                        {100 - userStats.verificationRate}%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-4806">
              <div className="flex justify-between items-center mb-4" data-id="element-4807">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-4808">
                  User Activity
                </h3>
                <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-4809">
                  <InfoIcon size={14} data-id="element-4810" />
                </button>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg mb-4" data-id="element-4811">
                <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4812">
                  Registration Trend
                </h4>
                <div className="flex items-center" data-id="element-4813">
                  <div className="flex-1" data-id="element-4814">
                    <div className="flex justify-between text-xs mb-1" data-id="element-4815">
                      <span className="text-gray-600" data-id="element-4816">This Month</span>
                      <span className="font-medium text-gray-900" data-id="element-4817">
                        {userStats.newUsersThisMonth}
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4818">
                      <div className="h-2 rounded-full bg-green-600" style={{
                      width: '75%'
                    }} data-id="element-4819"></div>
                    </div>
                  </div>
                  <div className="ml-4 flex items-center text-green-600 text-xs" data-id="element-4820">
                    <ArrowUpIcon size={14} className="mr-1" data-id="element-4821" />
                    <span data-id="element-4822">12%</span>
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-4823">
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4824">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4825">
                    Top Services Used
                  </h4>
                  <div className="space-y-2" data-id="element-4826">
                    <div className="flex items-center" data-id="element-4827">
                      <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-4828">
                        <FileTextIcon size={16} className="text-blue-600" data-id="element-4829" />
                      </div>
                      <div className="flex-1" data-id="element-4830">
                        <div className="flex justify-between" data-id="element-4831">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4832">
                            Business Registration
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4833">
                            32%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4834">
                          <div className="h-1.5 rounded-full bg-blue-600" style={{
                          width: '32%'
                        }} data-id="element-4835"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-4836">
                      <div className="p-2 bg-green-100 rounded-md mr-3" data-id="element-4837">
                        <FileTextIcon size={16} className="text-green-600" data-id="element-4838" />
                      </div>
                      <div className="flex-1" data-id="element-4839">
                        <div className="flex justify-between" data-id="element-4840">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4841">
                            Tax Clearance
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4842">
                            28%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4843">
                          <div className="h-1.5 rounded-full bg-green-600" style={{
                          width: '28%'
                        }} data-id="element-4844"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-4845">
                      <div className="p-2 bg-purple-100 rounded-md mr-3" data-id="element-4846">
                        <FileTextIcon size={16} className="text-purple-600" data-id="element-4847" />
                      </div>
                      <div className="flex-1" data-id="element-4848">
                        <div className="flex justify-between" data-id="element-4849">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4850">
                            Driver's License
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4851">
                            18%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4852">
                          <div className="h-1.5 rounded-full bg-purple-600" style={{
                          width: '18%'
                        }} data-id="element-4853"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-4854">
                      <div className="p-2 bg-yellow-100 rounded-md mr-3" data-id="element-4855">
                        <FileTextIcon size={16} className="text-yellow-600" data-id="element-4856" />
                      </div>
                      <div className="flex-1" data-id="element-4857">
                        <div className="flex justify-between" data-id="element-4858">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4859">
                            Land Documentation
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4860">
                            12%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4861">
                          <div className="h-1.5 rounded-full bg-yellow-600" style={{
                          width: '12%'
                        }} data-id="element-4862"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4863">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4864">
                    User Activity by Region
                  </h4>
                  <div className="space-y-2" data-id="element-4865">
                    <div className="flex items-center" data-id="element-4866">
                      <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-4867">
                        <MapPinIcon size={16} className="text-blue-600" data-id="element-4868" />
                      </div>
                      <div className="flex-1" data-id="element-4869">
                        <div className="flex justify-between" data-id="element-4870">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4871">
                            Lagos
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4872">
                            35%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4873">
                          <div className="h-1.5 rounded-full bg-blue-600" style={{
                          width: '35%'
                        }} data-id="element-4874"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-4875">
                      <div className="p-2 bg-green-100 rounded-md mr-3" data-id="element-4876">
                        <MapPinIcon size={16} className="text-green-600" data-id="element-4877" />
                      </div>
                      <div className="flex-1" data-id="element-4878">
                        <div className="flex justify-between" data-id="element-4879">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4880">
                            Abuja
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4881">
                            25%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4882">
                          <div className="h-1.5 rounded-full bg-green-600" style={{
                          width: '25%'
                        }} data-id="element-4883"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-4884">
                      <div className="p-2 bg-purple-100 rounded-md mr-3" data-id="element-4885">
                        <MapPinIcon size={16} className="text-purple-600" data-id="element-4886" />
                      </div>
                      <div className="flex-1" data-id="element-4887">
                        <div className="flex justify-between" data-id="element-4888">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4889">
                            Port Harcourt
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4890">
                            15%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4891">
                          <div className="h-1.5 rounded-full bg-purple-600" style={{
                          width: '15%'
                        }} data-id="element-4892"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-4893">
                      <div className="p-2 bg-yellow-100 rounded-md mr-3" data-id="element-4894">
                        <MapPinIcon size={16} className="text-yellow-600" data-id="element-4895" />
                      </div>
                      <div className="flex-1" data-id="element-4896">
                        <div className="flex justify-between" data-id="element-4897">
                          <span className="text-sm font-medium text-gray-900" data-id="element-4898">
                            Other Regions
                          </span>
                          <span className="text-sm font-medium text-gray-900" data-id="element-4899">
                            25%
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-4900">
                          <div className="h-1.5 rounded-full bg-yellow-600" style={{
                          width: '25%'
                        }} data-id="element-4901"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Help & Resources */}
          <div className="bg-white rounded-lg shadow p-4 mt-6" data-id="element-4902">
            <div className="flex justify-between items-center mb-4" data-id="element-4903">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-4904">
                User Management Resources
              </h3>
              <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-4905">
                <MoreHorizontalIcon size={14} data-id="element-4906" />
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4907">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-4908">
                <div className="flex items-start" data-id="element-4909">
                  <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-4910">
                    <ClipboardIcon size={20} className="text-blue-600" data-id="element-4911" />
                  </div>
                  <div data-id="element-4912">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-4913">
                      User Management Guidelines
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-4914">
                      Learn about user management best practices, verification
                      procedures, and access control.
                    </p>
                    <a href="#" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-4915">
                      View Guidelines
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-4916" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-4917">
                <div className="flex items-start" data-id="element-4918">
                  <div className="p-2 bg-purple-100 rounded-md mr-3" data-id="element-4919">
                    <ShieldIcon size={20} className="text-purple-600" data-id="element-4920" />
                  </div>
                  <div data-id="element-4921">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-4922">
                      User Verification Process
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-4923">
                      Understand the verification workflow and how to validate
                      user identities.
                    </p>
                    <a href="#" className="text-xs text-purple-600 hover:text-purple-800 flex items-center" data-id="element-4924">
                      View Process
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-4925" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-4926">
                <div className="flex items-start" data-id="element-4927">
                  <div className="p-2 bg-green-100 rounded-md mr-3" data-id="element-4928">
                    <HelpCircleIcon size={20} className="text-green-600" data-id="element-4929" />
                  </div>
                  <div data-id="element-4930">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-4931">
                      User Support Resources
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-4932">
                      Access resources to help users with common account issues
                      and questions.
                    </p>
                    <a href="#" className="text-xs text-green-600 hover:text-green-800 flex items-center" data-id="element-4933">
                      View Resources
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-4934" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      {/* Delete User Modal */}
      {showDeleteModal && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-4935">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-4936">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-4937">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-4938">Delete User</h3>
            </div>
            <div className="p-6" data-id="element-4939">
              <div className="mb-4" data-id="element-4940">
                <div className="flex items-center mb-4" data-id="element-4941">
                  <div className="flex-shrink-0 bg-red-100 rounded-full p-2 mr-3" data-id="element-4942">
                    <AlertTriangleIcon size={24} className="text-red-600" data-id="element-4943" />
                  </div>
                  <div data-id="element-4944">
                    <h3 className="text-sm font-medium text-gray-900" data-id="element-4945">
                      Are you sure you want to delete this user?
                    </h3>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-4946">
                      This action cannot be undone. All data associated with
                      this user will be permanently removed.
                    </p>
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-4947">
                  <p className="text-sm text-gray-700 mb-2" data-id="element-4948">
                    <span className="font-medium" data-id="element-4949">User:</span>{' '}
                    {users.find(u => u.id === userToDelete)?.firstName}{' '}
                    {users.find(u => u.id === userToDelete)?.lastName}
                  </p>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-4950">
                    <span className="font-medium" data-id="element-4951">Email:</span>{' '}
                    {users.find(u => u.id === userToDelete)?.email}
                  </p>
                  <p className="text-sm text-gray-700" data-id="element-4952">
                    <span className="font-medium" data-id="element-4953">ID:</span>{' '}
                    {users.find(u => u.id === userToDelete)?.userId}
                  </p>
                </div>
              </div>
            </div>
            <div className="px-6 py-3 border-t border-gray-200 flex justify-end space-x-3" data-id="element-4954">
              <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-4955">
                Cancel
              </button>
              <button onClick={processDelete} disabled={isProcessing} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-4956">
                {isProcessing ? <>
                    <RefreshCwIcon size={16} className="inline mr-2 animate-spin" data-id="element-4957" />
                    Processing...
                  </> : 'Delete User'}
              </button>
            </div>
          </div>
        </div>}
      {/* Create User Modal would go here */}
      {/* Edit User Modal would go here */}
    </div>;
};
export default UserManagement;